import { s as t } from "./string-multibyte.js";
var r = t.charAt,
  n = function n(t, _n, a) {
    return _n + (a ? r(t, _n).length : 1);
  };
export { n as a };